import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.jpg";
import Tilt from "react-parallax-tilt";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
// import {
//   AiFillGithub,
//   AiOutlineTwitter,
//   AiFillInstagram,
// } from "react-icons/ai";
// import { FaLinkedinIn } from "react-icons/fa";

import "./home.css"

function Home() {
  return (
    <div id="home">
      {/* <Container fluid className="home-section" id="home"> */}
      <Container>
        <Particle id="webpar"></Particle>
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> Keshav</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>


            <Col md={5} style={{ paddingBottom: 20 }}>
              <Tilt>
                <img
                  src={homeLogo}
                  alt="home pic"
                  className="img-fluid"
                  // className="rounded-circle mb-3"
                  id="myImg"
                  style={{
                    maxHeight: "450px",
                    borderRadius: "50%",
                  }}
                />
              </Tilt>
            </Col>

          </Row>





        </Container>

      </Container>

      {/* <div className="m-5">
        <h1 className="lheading">
          <a href="https://keshavlinktree.web.app" target="blank"><button>Visit all links<i class="fas fa-arrow-circle-up"></i></button>
          </a>
        </h1>
        <Row>
          <Col md={3} className="lbtn">
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/keshavop"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/keshavkop"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/keshavop"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/keshav_0p"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </div> */}

      <Home2 />
    </div>
  );
}

export default Home;
